import { AnalyticBaseProperties } from './analytic-base-properties.model';
import { EBannerStatus } from './enums/analytic-banner-status.enum';

export class AnalyticPilotPrecheckinProperties extends AnalyticBaseProperties {
  trainingId: string;
  geminiTrainingCenterId: string;
  trainingCenterName: string;
  visitId: string;
  duration: number;
  path: string;
  licenseAuthority: string;
  hotelInfoFilled: boolean;
  qrCodeGenerated: boolean;
  documentType: string;
  documentStatus: string;
  bannerStatus?: EBannerStatus;

  constructor(
    visitId: string,
    trainingId: string,
    duration: number,
    geminiTrainingCenterId: string,
    trainingCenterName: string,
    path: string,
    licenseAuthority: string,
    hotelInfoFilled: boolean,
    qrCodeGenerated: boolean,
    documentType: string = null,
    documentStatus: string = null,
    bannerStatus: EBannerStatus = null
  ) {
    super();

    this.visitId = visitId;
    this.trainingId = trainingId;
    this.duration = duration;
    this.geminiTrainingCenterId = geminiTrainingCenterId;
    this.trainingCenterName = trainingCenterName;
    this.path = path;
    this.licenseAuthority = licenseAuthority;
    this.hotelInfoFilled = hotelInfoFilled;
    this.qrCodeGenerated = qrCodeGenerated;
    this.documentType = documentType;
    this.documentStatus = documentStatus;
    this.bannerStatus = bannerStatus;
  }

  override parse(): AnalyticPilotPrecheckinProperties {
    const fromSuper = super.parse();
    fromSuper.visitId = this.visitId;
    fromSuper.trainingId = this.trainingId;
    fromSuper.duration = this.duration;
    fromSuper.geminiTrainingCenterId = this.geminiTrainingCenterId;
    fromSuper.trainingCenterName = this.trainingCenterName;
    fromSuper.path = this.path;
    fromSuper.licenseAuthority = this.licenseAuthority;
    fromSuper.hotelInfoFilled = this.hotelInfoFilled;
    fromSuper.qrCodeGenerated = this.qrCodeGenerated;
    fromSuper.documentType = this.documentType;
    fromSuper.documentStatus = this.documentStatus;
    fromSuper.bannerStatus = this.bannerStatus;

    return fromSuper;
  }
}
